<template>
    <div class="card mb-0 shadow">
        <div class="card-body">
            <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                    <div class="row col-12 pb-3 px-0 m-0 d-flex justify-content-between">
                        <h4 class="font-weight-bold">Primeiras Observação</h4>
                    </div>
                    <load mode="table" v-if="loading" />

                    <template v-if="isIdoso">

                        <div class="row">
                            <form-select
                                v-model="primeiraObservacao.idoso.condicao_higiene"
                                :itens="$root.arrays.pergunta"
                                label="A pessoa idosa encontrava-se em boas condições de higiene?"
                                :required="true"
                            />
                            <form-select
                                v-model="primeiraObservacao.idoso.chegou_agitada"
                                :itens="$root.arrays.pergunta"
                                label="A pessoa idosa estava agitado(a) ao ingressar na unidade?"
                                :required="true"
                            />
                            <form-select
                                v-model="primeiraObservacao.idoso.dificuldade_dormir"
                                :itens="$root.arrays.pergunta"
                                label="A pessoa idosa apresentou dificuldade para dormir?"
                                :required="true"
                            />
                            <form-select
                                v-model="primeiraObservacao.idoso.vestigio_psicoativo"
                                :itens="$root.arrays.pergunta"
                                label="A pessoa idosa apresentava vestígios do uso de alguma substância psicoativa?"
                                :required="true"
                            />
                            <form-select
                                v-model="primeiraObservacao.idoso.violencia_fisica"
                                :itens="$root.arrays.pergunta"
                                label="A pessoa idosa apresentava algum sinal de violência física?"
                                :required="true"
                            />
                            <form-select
                                v-model="primeiraObservacao.idoso.violacia_sexual"
                                :itens="$root.arrays.pergunta"
                                label="A pessoa idosa apresentava algum sinal de violência sexual?"
                                :required="true"
                            />
                            <form-select
                                v-model="primeiraObservacao.idoso.vivencia_negligencia"
                                :itens="$root.arrays.pergunta"
                                label="A pessoa idosa apresentava aspectos que indicam a vivência de negligência?"
                                :required="true"
                            />
                        </div>

                        <h3 class="mt-3">Aspectos pessoais observados</h3>
                    
                        <div class="row">
                            <form-select
                                v-model="primeiraObservacao.idoso.aspectos_pessoais"
                                :itens="
                                    $root.arrays.acolhimento_aspectos_pessoais_idoso
                                "
                                label="Aspectos pessoais observados:"
                                :multiple="true"
                            />
                            <form-input-tag
                                v-model="primeiraObservacao.idoso.aspectos_pessoais_outros"
                                label="Outros (Aperte ENTER, para inserir um ou mais)"
                            />
                            <form-textarea-editor
                                label="Percepção da Equipe SUAS"
                                :required="true"
                                v-model="primeiraObservacao.idoso.parecer_equipe_tecnica"
                            />
                        </div>

                    </template>

                    <template v-else>

                        <div class="row">
                            <div class="col-12">

                                <h3>Pessoas Vinculadas ao Acolhimento:</h3>

                                <b-table :items="todasPessoas" :fields="['nome', 'idade', 'parentesco']" small responsive>
                                    <template #cell(nome)="row">
                                        <a href="#" @click.prevent="selecionarPessoa(row.item)">
                                            {{ row.item.nome }}
                                        </a>
                                    </template>
                                </b-table>

                                <div v-if="pessoaSelecionada">

                                    <br><br>

                                    <h3> Primeira Observação de: {{ pessoaSelecionada.nome }}</h3>

                                    <form-select
                                        v-model="primeiraObservacaoSelecionada.chegou_agitada"
                                        :itens="$root.arrays.pergunta"
                                        label="A pessoa estava agitada(o) ao ingressar na unidade?"
                                        :required="true"
                                    />

                                    <form-select
                                        v-model="primeiraObservacaoSelecionada.vestigio_psicoativo"
                                        :itens="$root.arrays.pergunta"
                                        label="A pessoa apresentava vestígios de uso de alguma substância psicoativa?"
                                        :required="true"
                                    />
                                    
                                    <form-select
                                        v-model="primeiraObservacaoSelecionada.violencia_fisica"
                                        :itens="$root.arrays.pergunta"
                                        label="A pessoa apresentava algum sinal de violência física?"
                                        :required="true"
                                    />

                                    <form-select
                                        v-model="primeiraObservacaoSelecionada.violacia_sexual"
                                        :itens="$root.arrays.pergunta"
                                        label="A pessoa apresentava algum sinal de violência sexual?"
                                        :required="true"
                                    />

                                    <form-textarea-editor
                                        label="Percepção da Equipe SUAS"
                                        :required="true"
                                        v-model="primeiraObservacaoSelecionada.parecer_equipe_tecnica"
                                    />
                                </div>
                            </div>
                        </div>
                    </template>
                    
                    <div class="row pt-4 px-0 d-flex justify-content-end">
                        <div class="col-auto px-2 text-right">
                            <button
                                class="btn btn-success btn-submit"
                                @click="submit"
                            >
                                <i class="mdi mdi-content-save" />
                                {{ $t("Salvar") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            loading: false,
            primeiraObservacao: {
                idoso: {
                    condicao_higiene: null,
                    chegou_agitada: null,
                    chegou_chorando: null,
                    dificuldade_dormir: null,
                    enurese_noturna: null,
                    vestigio_psicoativo: null,
                    violencia_fisica: null,
                    violacia_sexual: null,
                    vivencia_negligencia: null,
                    aspectos_pessoais: null,
                    aspectos_pessoais_outros: null
                },
                pessoasVinculadas: []
            },
            primeiraObservacaoSelecionada: null,
            pessoaReferencia: [],
            pessoaSelecionada: null,
        };
    },
    computed: {
        todasPessoas() {
            const pessoaPrincipal = {
                id: 'principal',
                nome: this.item.nome_acolhido,
                idade: this.calcularIdade(this.item.nascimento),
                parentesco: 'Acolhido(a)',
                tipo_cadastro: 'Principal',
            };

            const vinculados = this.pessoaReferencia.filter(
                p => p.tipo_cadastro === 'Familiar' || p.tipo_cadastro === 'Crianca'
            );

            return [pessoaPrincipal, ...vinculados];
        },
        isIdoso() {

            const hoje = moment();
            const nascimento = moment(this.item.nascimento, "YYYY-MM-DD");
            const idade = hoje.diff(nascimento, 'years');

            // Se existir público alvo, verifica se é 8, senão usa idade para decidir
            return this.item.solicitacao?.publico_alvo_id === 8 || idade >= 60;
        },
    },
    watch: {
        item: {
            immediate: true,
            handler(newVal) {
                if (newVal.primeiraObservacao) {
                    this.primeiraObservacao.idoso = newVal.primeiraObservacao.idoso
                        ? this.preencherPrimeiraObservacao(newVal.primeiraObservacao.idoso)
                        : this.preencherPrimeiraObservacao(null);

                    this.primeiraObservacao.pessoasVinculadas = newVal.primeiraObservacao.pessoasVinculadas || [];
                } else {
                    this.primeiraObservacao.idoso = this.preencherPrimeiraObservacao(null);
                    this.primeiraObservacao.pessoasVinculadas = [];
                }

                if (newVal.pessoaReferencia) {
                    this.pessoaReferencia = newVal.pessoaReferencia;
                }
            }
        },
    },
    mounted() {
        if (this.item.primeiraObservacao) {
            this.primeiraObservacao.idoso = this.item.primeiraObservacao?.idoso
                ? this.preencherPrimeiraObservacao(this.item.primeiraObservacao.idoso)
                : this.preencherPrimeiraObservacao(null);

            this.primeiraObservacao.pessoasVinculadas = this.item.primeiraObservacao?.pessoasVinculadas || [];
        }

        if (this.item.pessoaReferencia != null) {
            this.pessoaReferencia = this.item.pessoaReferencia;
        }
    },
    methods: {
        calcularIdade(dataNasc) {
            if (!dataNasc) return null;
            const hoje = new Date();
            const nasc = new Date(dataNasc);
            let idade = hoje.getFullYear() - nasc.getFullYear();
            const m = hoje.getMonth() - nasc.getMonth();
            if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) {
                idade--;
            }
            return idade;
        },
        preencherPrimeiraObservacao(obj) {
            const campos = [
                'condicao_higiene',
                'chegou_agitada',
                'chegou_chorando',
                'dificuldade_dormir',
                'enurese_noturna',
                'vestigio_psicoativo',
                'violencia_fisica',
                'violacia_sexual',
                'vivencia_negligencia',
                'aspectos_pessoais',
                'aspectos_pessoais_outros'
            ];

            if (!obj) obj = {};
            campos.forEach(campo => {
                if (obj[campo] === null || obj[campo] === undefined) {
                    obj[campo] = null;
                }
            });

            return obj;
        },
        submit() {

            if (this.pessoaSelecionada) {
                if (this.pessoaSelecionada.tipo_cadastro === 'Principal') {
                    this.primeiraObservacao.idoso = { ...this.primeiraObservacaoSelecionada };
                } else {
                    this.pessoaSelecionada.caracteristica_primeira_observacao = { ...this.primeiraObservacaoSelecionada };
                }
            }

            /*if (this.pessoaSelecionada) {
                const index = this.pessoaReferencia.findIndex(p => p.id === this.pessoaSelecionada.id);
                if (index !== -1) {
                    this.pessoaReferencia[index].caracteristica_primeira_observacao = { ...this.primeiraObservacaoSelecionada };
                }
            }*/

            this.item.primeiraObservacao = {
                idoso: this.primeiraObservacao.idoso,
                pessoasVinculadas: this.pessoaReferencia
                    .filter(p => p.caracteristica_primeira_observacao)
                    .map(p => ({
                        ...p.caracteristica_primeira_observacao,
                        pessoa_referencia_id: p.id,
                    }))
            };

            this.$emit("submit");
        },
        verificarValueArray(value, array, valueIsArray = false) {
            if (valueIsArray && value) {
                var a = "";
                for (var i = 0; i < value.length; i++) {
                    const result = array.filter(item => item.id == value[i]);
                    a += result[0].value + (i < value.length - 1 ? "," : "");
                }
                return a;
            } else {
                const result = array.filter(item => item.id == value);
                return result[0] ? result[0].value : "";
            }
        },  
        selecionarPessoa(pessoa) {
            this.pessoaSelecionada = pessoa;

            if (pessoa.tipo_cadastro === 'Principal') {

                this.primeiraObservacaoSelecionada = { ...this.primeiraObservacao.idoso };

            }else{

                const dadosPrimeiraObservacao = this.item.primeiraObservacao?.pessoasVinculadas?.find(
                    cs => cs.pessoa_referencia_id === pessoa.id
                );

                this.primeiraObservacaoSelecionada = dadosPrimeiraObservacao ? { ...dadosPrimeiraObservacao } : {
                    pessoa_referencia_id: pessoa.id,
                    condicao_higiene: null,
                    chegou_agitada: null,
                    chegou_chorando: null,
                    dificuldade_dormir: null,
                    enurese_noturna: null,
                    vestigio_psicoativo: null,
                    violencia_fisica: null,
                    violacia_sexual: null,
                    vivencia_negligencia: null,
                    aspectos_pessoais: null,
                    aspectos_pessoais_outros: null
                };
            }
        },
    },
};
</script>
